import SitemapPage from '@/pages/sitemap/SitemapPage.vue'

export default [
  {
  path: '/sitemap/',
  component: SitemapPage,
  props: true
  }
]